import srtValidator from 'srt-validator';
import { EConvertType } from '../@types/Convert';

export function CheckConvertTypeCompatible(first: EConvertType | null, second: EConvertType | null) {
    if(!first || !second) return false;
    
    switch(first) {
        // SRT
        case EConvertType.SrtToFCPXML:
        case EConvertType.SrtToWebVTT:
        case EConvertType.SrtToAvidSubCap:
        case EConvertType.SrtToEDL:
            if([EConvertType.SrtToFCPXML, EConvertType.SrtToWebVTT, EConvertType.SrtToAvidSubCap, EConvertType.SrtToEDL].indexOf(second) == -1)
                return false;
            return true;
        // XML
        case EConvertType.XMLToFCPXML: 
            if([EConvertType.XMLToFCPXML].indexOf(second) == -1)
                return false;
            return true;
        default: return false;
    }
}

export function IsValidSrtContent(text: string): boolean {
    let errors = srtValidator(text);

    errors = errors.filter((e) => {
        if(['validatorErrorEndTime'].indexOf(e.errorCode) !== -1) return false;
        return true;
    })

    return errors.length <= 0 ? true : false;
}

export function IsValidEmail(email: string): boolean {
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email));
}

export function AnalyzeXMLObject(xml: any) {
    try {
        var bin = xml.xmeml.bin;
        var dFileName = bin.name;

        var dTranscripts: any[] = [], dSegments: any[] = [];

        // Media
        var binMedia = bin.children.bin.find((b: any) => b.name == 'Media');
        var clip = binMedia.children.clip;

        var dFramerate = Number(clip.rate.timebase);
        var dFilePath = clip.media.video.track.clipitem.file.pathurl;
        var dDuration = Number((Number(clip.media.video.track.clipitem.file.duration) / dFramerate).toFixed(2));
        var dWidth = Number(clip.media.video.track.clipitem.file.media.video.samplecharacteristics.width);
        var dHeight = Number(clip.media.video.track.clipitem.file.media.video.samplecharacteristics.height);

        if(clip.marker && Array.isArray(clip.marker)) {
            clip.marker.forEach((m: any) => { dTranscripts.push({
                startTime: Number((Number(m.in) / dFramerate).toFixed(2)),
                endTime: Number((Number(m.out) / dFramerate).toFixed(2)),
                value: m.comment
            }) });
        }

        // Sequence
        var binSequence = bin.children.bin.find((b: any) => b.name == 'Sequence');
        binSequence.children.sequence.marker.forEach((m: any, i: number) => { 
            dSegments.push({
                text: m.comment,
                start: Number((Number(binSequence.children.sequence.media.video.track.clipitem[i].start) / dFramerate).toFixed(2)),
                end: Number((Number(binSequence.children.sequence.media.video.track.clipitem[i].end) / dFramerate).toFixed(2))
            })
        });

        return MakeConvertObject({ dFileName, dFilePath, dFramerate, dDuration, dWidth, dHeight, dTranscripts, dSegments })
    } catch(err: any) {
        console.error(err);
        return null;
    }
}

function MakeConvertObject(config: any) {
    const { dFileName, dFilePath, dFramerate, dDuration, dWidth, dHeight, dTranscripts, dSegments } = config;
  
    var data = {
      "media": [
        {
          "mediaInfo": {
            "id": 0,
            "name": dFileName,
            "url": dFilePath,
            "startTimeCode": "00:00:00:00",
            "durationInSeconds": dDuration,
            "width": dWidth,
            "height": dHeight,
            "fps": dFramerate,
            "localClientPathFile": dFilePath
          },
          "transcriptRows": dTranscripts
        }
      ],
      "segments": dSegments.map((s: any, i: number) => ({
        "id": i,
        "start": s.start,
        "end": s.end,
        "text": s.text,
        "sort_index": 0,
        "imported_media": { "id": 0, "startTimeCode": "00:00:00:00" }
      })),
      "project": {
        "name": dFileName,
        "creation_date": new Date().toISOString(),
        "width": dWidth,
        "height": dHeight,
        "fps": dFramerate,
        "timecode": "00:00:00:00"
      },
      "fileType": "premiere"
    }  
  
    return data;
}